/** 侧栏 / 权限页模块 accent 色（与 demo group-title 分区对应） */
export const MODULE_ACCENTS = [
  { border: '#1890ff', bg: '#e6f7ff', text: '#096dd9' },
  { border: '#722ed1', bg: '#f9f0ff', text: '#531dab' },
  { border: '#13c2c2', bg: '#e6fffb', text: '#08979c' },
  { border: '#52c41a', bg: '#f6ffed', text: '#389e0d' },
  { border: '#fa8c16', bg: '#fff7e6', text: '#d46b08' },
  { border: '#eb2f96', bg: '#fff0f6', text: '#c41d7f' },
  { border: '#2f54eb', bg: '#f0f5ff', text: '#1d39c4' },
  { border: '#fa541c', bg: '#fff2e8', text: '#d4380d' },
  { border: '#a0d911', bg: '#fcffe6', text: '#7cb305' },
  { border: '#597ef7', bg: '#f0f5ff', text: '#2f54eb' }
]

/** API 不可用时的侧栏兜底（与 demo shell.js 一致） */
export const FALLBACK_MENU = [
  { key: 'dashboard', text: '经营驾驶舱', icon: '📊', path: '/dashboard', menuCode: 'menu:dashboard' },
  { group: '客户管理' },
  { key: 'customer', text: '客户管理', icon: '👥', path: '/customer', menuCode: 'menu:customer' },
  { group: '销售管理' },
  { key: 'opportunity', text: '商机管理', icon: '🎯', path: '/opportunity', menuCode: 'menu:opportunity' },
  { key: 'quote', text: '销售报价', icon: '💱', path: '/quote', menuCode: 'menu:quote' },
  { key: 'contract', text: '合同管理', icon: '📄', path: '/contract', menuCode: 'menu:contract' },
  { key: 'agent', text: '代理商管理', icon: '🤝', path: '/agent', menuCode: 'menu:agent' },
  { key: 'sales-target', text: '销售目标达成', icon: '🏁', path: '/sales-target', menuCode: 'menu:sales-target' },
  { key: 'sales-perf', text: '销售业绩提成', icon: '🏆', path: '/sales-perf', menuCode: 'menu:sales-perf' },
  { group: '物料库存' },
  { key: 'material', text: '销售项目', icon: '📦', path: '/material', menuCode: 'menu:material' },
  { key: 'inventory', text: '库存管理', icon: '🏬', path: '/inventory', menuCode: 'menu:inventory' },
  { group: '项目交付' },
  { key: 'project', text: '项目管理', icon: '📁', path: '/project', menuCode: 'menu:project' },
  { key: 'shipment', text: '发货管理', icon: '🚚', path: '/shipment', menuCode: 'menu:shipment' },
  { key: 'delivery', text: '交付管理', icon: '✅', path: '/delivery', menuCode: 'menu:delivery' },
  { key: 'invoice', text: '开票管理', icon: '🧾', path: '/invoice', menuCode: 'menu:invoice' },
  { group: '收款管理' },
  { key: 'receivable', text: '应收管理', icon: '💰', path: '/receivable', menuCode: 'menu:receivable' },
  { key: 'receipt', text: '回款管理', icon: '💵', path: '/receipt', menuCode: 'menu:receipt' },
  { group: '成本付款' },
  { key: 'expense', text: '支出录入', icon: '➖', path: '/expense', menuCode: 'menu:expense' },
  { key: 'payable', text: '应付管理', icon: '💳', path: '/payable', menuCode: 'menu:payable' },
  { group: '经营分析' },
  { key: 'pnl', text: '公司利润表', icon: '🧮', path: '/pnl', menuCode: 'menu:pnl' },
  { key: 'cashflow', text: '现金流量表', icon: '💧', path: '/cashflow', menuCode: 'menu:cashflow' },
  { key: 'profit-project', text: '项目利润分析', icon: '📈', path: '/profit-project', menuCode: 'menu:profit-project' },
  { key: 'profit-customer', text: '客户利润分析', icon: '📉', path: '/profit-customer', menuCode: 'menu:profit-customer' },
  { key: 'profit-agent', text: '代理商利润分析', icon: '🤝', path: '/profit-agent', menuCode: 'menu:profit-agent' },
  { key: 'sales-item-analysis', text: '销售项目分析', icon: '🧾', path: '/sales-item-analysis', menuCode: 'menu:sales-item-analysis' },
  { key: 'sales-region', text: '区域行业分析', icon: '🗺️', path: '/sales-region', menuCode: 'menu:sales-region' },
  { key: 'efficiency', text: '人效分析', icon: '👤', path: '/efficiency', menuCode: 'menu:efficiency' },
  { key: 'report', text: '年度营收报表', icon: '📋', path: '/report', menuCode: 'menu:report' },
  { key: 'forecast', text: '经营预测', icon: '🔮', path: '/forecast', menuCode: 'menu:forecast' },
  { group: '运营协同' },
  { key: 'service-ticket', text: '售后与服务', icon: '🛠️', path: '/service-ticket', menuCode: 'menu:service-ticket' },
  { key: 'reminder', text: '提醒中心', icon: '🔔', path: '/reminder', menuCode: 'menu:reminder' },
  { key: 'rules', text: '规则与分摊', icon: '📐', path: '/rules', menuCode: 'menu:rules' },
  { group: '系统设置' },
  { key: 'user', text: '用户管理', icon: '👤', path: '/user', menuCode: 'menu:user' },
  { key: 'role', text: '角色管理', icon: '👔', path: '/role', menuCode: 'menu:role' },
  { key: 'role-permission', text: '权限分配', icon: '🗝️', path: '/role-permission', menuCode: 'menu:role-permission' },
  { key: 'permission', text: '字段权限', icon: '🔐', path: '/permission', menuCode: 'menu:permission' }
]

export function moduleAccentStyle(accentIndex) {
  const a = MODULE_ACCENTS[accentIndex % MODULE_ACCENTS.length]
  return {
    borderLeftColor: a.border,
    background: `linear-gradient(90deg, ${a.bg} 0%, #fff 72%)`,
    color: a.text
  }
}

export function flattenMenusFromModules(modules) {
  const list = []
  ;(modules || []).forEach((mod) => {
    ;(mod.menus || []).forEach((m) => list.push(m))
  })
  return list
}

export function findMenuInModules(modules, key) {
  for (const mod of modules || []) {
    const menu = (mod.menus || []).find((m) => m.key === key)
    if (menu) return menu
  }
  return null
}
